<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="reportSource">Report Source</label>
                    <wj-combo-box
                        id="reportSource"
                        [(ngModel)]="target.reportSource"
                        name="reportSource"
                        [itemsSource]="reportSourceOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="labName">Lab Name</label>
                    <input type="text" class="form-control" id="labName" [(ngModel)]="target.labName" name="labName" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="reportNumber">Report Number</label>
                    <input type="text" class="form-control" id="reportNumber" [(ngModel)]="target.reportNumber" name="reportNumber" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="inspector">Inspector</label>
                    <input type="text" class="form-control" id="inspector" [(ngModel)]="target.inspector" name="inspector" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="serviceDate">Service Date</label>
                    <input type="text" class="form-control" id="serviceDate" [(ngModel)]="target.serviceDate" name="serviceDate" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="reportDate">Report Date</label>
                    <input type="text" class="form-control" id="reportDate" [(ngModel)]="target.reportDate" name="reportDate" />
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="generalLocation">General Location</label>
                    <input type="text" class="form-control" id="generalLocation" [(ngModel)]="target.generalLocation" name="generalLocation" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="testMethod">Test Method</label>
                    <input type="text" class="form-control" id="testMethod" [(ngModel)]="target.testMethod" name="testMethod" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="proctorNo">Proctor No</label>
                    <input type="text" class="form-control" id="proctorNo" [(ngModel)]="target.proctorNo" name="proctorNo" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="soilDescription">Soil Description</label>
                    <input type="text" class="form-control" id="soilDescription" [(ngModel)]="target.soilDescription" name="soilDescription" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="gaugeMake">Gauge Make</label>
                    <input type="text" class="form-control" id="gaugeMake" [(ngModel)]="target.gaugeMake" name="gaugeMake" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="gaugeModel">Gauge Model</label>
                    <input type="text" class="form-control" id="gaugeModel" [(ngModel)]="target.gaugeModel" name="gaugeModel" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="gaugeSerial">Gauge Serial</label>
                    <input type="text" class="form-control" id="gaugeSerial" [(ngModel)]="target.gaugeSerial" name="gaugeSerial" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="gaugeCalibrationDate">Gauge Calibration Date</label>
                    <input
                        type="text"
                        class="form-control"
                        id="gaugeCalibrationDate"
                        [(ngModel)]="target.gaugeCalibrationDate"
                        name="gaugeCalibrationDate"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="standardCountDensity">Std Count (Density)</label>
                    <input
                        type="text"
                        class="form-control"
                        id="standardCountDensity"
                        [(ngModel)]="target.standardCountDensity"
                        name="standardCountDensity"
                    />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="standardCountMoisture">Std Count (Moisture)</label>
                    <input
                        type="text"
                        class="form-control"
                        id="standardCountMoisture"
                        [(ngModel)]="target.standardCountMoisture"
                        name="standardCountMoisture"
                    />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="maxDryDensityPcf">Max Dry Density (pcf)</label>
                    <input type="text" class="form-control" id="maxDryDensityPcf" [(ngModel)]="target.maxDryDensityPcf" name="maxDryDensityPcf" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="optimumMoisturePct">Optimum Moisture (%)</label>
                    <input
                        type="text"
                        class="form-control"
                        id="optimumMoisturePct"
                        [(ngModel)]="target.optimumMoisturePct"
                        name="optimumMoisturePct"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="requiredCompactionPct">Required Compaction (%)</label>
                    <input
                        type="text"
                        class="form-control"
                        id="requiredCompactionPct"
                        [(ngModel)]="target.requiredCompactionPct"
                        name="requiredCompactionPct"
                    />
                </div>
            </div>
            <div class="col-md-8 mb-3">
                <div class="form-group">
                    <label for="projectSpecification">Project Specification</label>
                    <input
                        type="text"
                        class="form-control"
                        id="projectSpecification"
                        [(ngModel)]="target.projectSpecification"
                        name="projectSpecification"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="weather">Weather</label>
                    <input type="text" class="form-control" id="weather" [(ngModel)]="target.weather" name="weather" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="startTime">Start Time</label>
                    <input type="text" class="form-control" id="startTime" [(ngModel)]="target.startTime" name="startTime" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="stopTime">Stop Time</label>
                    <input type="text" class="form-control" id="stopTime" [(ngModel)]="target.stopTime" name="stopTime" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="standardHours">Standard Hours</label>
                    <input type="text" class="form-control" id="standardHours" [(ngModel)]="target.standardHours" name="standardHours" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="overtimeHours">Overtime Hours</label>
                    <input type="text" class="form-control" id="overtimeHours" [(ngModel)]="target.overtimeHours" name="overtimeHours" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="travelHours">Travel Hours</label>
                    <input type="text" class="form-control" id="travelHours" [(ngModel)]="target.travelHours" name="travelHours" />
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="remarks">Remarks</label>
                    <textarea class="form-control" id="remarks" rows="2" [(ngModel)]="target.remarks" name="remarks"></textarea>
                </div>
            </div>
        </div>

        <hr />
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">Field Density Test Results</h5>
            <div>
                <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="addTest()">Add Row</button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteTest()">Delete Row</button>
            </div>
        </div>
        <wj-flex-grid #testGridRef style="height: 220px" (initialized)="testGrid.initialize(testGridRef)" [itemsSource]="testGrid.view">
            <wj-flex-grid-column [header]="'Test #'" [binding]="'testNo'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Date'"
                [binding]="'testDate'"
                [width]="90"
                [editor]="inputDate"
                [format]="'d'"
                [isRequired]="false"
            ></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Mode'" [binding]="'testMode'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Elevation'" [binding]="'elevation'" [width]="90"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Location'" [binding]="'location'" [width]="150"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Depth (in)'" [binding]="'depthIn'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Water %'" [binding]="'waterContentPct'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Wet (pcf)'" [binding]="'wetDensityPcf'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Dry (pcf)'" [binding]="'dryDensityPcf'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Max (pcf)'" [binding]="'maxDensityPcf'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Comp. %'" [binding]="'compactionPct'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Required %'" [binding]="'requiredPct'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Pass/Fail'" [binding]="'passFail'" [dataMap]="passFailMap" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Comments'" [binding]="'comments'" width="*"></wj-flex-grid-column>
            <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
        </wj-flex-grid>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
